module.exports = __webpack_public_path__ + "static/media/option-1.8f9d95ec.ogg";